export const headerData = [
  {
    text: "",
  },
  {
    text: "Items",
  },
  {
    text: "Price",
  },
];

export const bodyDataAndKeyTypes = [
  {
    key: "isChecked",
    type: "checkbox",
    prepend: "",
  },
  {
    key: "itemName",
    type: "",
    prepend: "",
  },
  {
    key: "itemPrice",
    type: "",
    prepend: "Rs. ",
  },
];

export const footerData = {
  title: "No record found",
  subTtitle: "No such order exists. Create one?",
  imgSrc: "../../../assets/images/no-search-icon.svg",
  alt: "no search found",
};
